<div class="message">
    <app-icon [attr.aria-label]="logo.alt" [svgIcon]="ICONS.AMAGNO_LOGO" class="logo amagno-logo" qaTag="splash-screen-logo" role="img"/>
    <p class="text" data-qa="splash-screen-text">{{ 'SPLASH_SCREEN_MESSAGE'|translate }}</p>
    <app-loading-spinner class="loading-spinner" data-qa="splash-screen-loading-spinner"/>
</div>
